<template>
	<div class="dot">
		<h4>Gender Distribution</h4>
		<Doughnut
			:chart-options="chartOptions"
			:chart-data="data"
			:chart-id="chartId"
			:dataset-id-key="datasetIdKey"
			:plugins="plugins"
			:css-classes="cssClasses"
			:styles="styles"
			:width="width"
			:height="height"
			style="max-width: 300px; margin: 2rem auto"
		/>
	</div>
</template>

<script>
import { Doughnut } from "vue-chartjs";
import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	BarElement,
	ArcElement,
	CategoryScale,
	LinearScale
} from "chart.js";

ChartJS.register(
	Title,
	Tooltip,
	Legend,
	BarElement,
	ArcElement,
	CategoryScale,
	LinearScale
);
export default {
	name: "DoughnutChart",
	components: {
		Doughnut
	},
	props: {
		chartId: {
			type: String,
			default: "bar-chart"
		},
		datasetIdKey: {
			type: String,
			default: "label"
		},
		data: {
			type: Object
		},
		width: {
			type: String,
			default: "100px"
		},
		height: {
			type: String,
			default: "100px"
		},
		cssClasses: {
			default: "",
			type: String
		}
	}
};
</script>

<style lang="scss" scoped>
.dot {
	width: 45%;
	background: #fff;
	padding: 50px;
	border-radius: 5px;

	@include respond-to(laptop) {
		padding: 10px;
	}

	@include respond-to(tablet) {
		margin-top: 50px;
		width: 100%;
	}
}
</style>
